var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content custom-scroll"},_vm._l((_vm.entriesPro),function(entry,index){return _c('p-entry',{key:index,attrs:{"entry":_vm.entriesPro[index]},nativeOn:{"click":function($event){return _vm.openSlideover($event, index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }